import { jsx as e } from "react/jsx-runtime";
import * as i from "react";
var l = (r) => typeof r == "string" || typeof r == "number" ? /* @__PURE__ */ e("span", {
  className: "lib:line-clamp-1 lib:text-ellipsis",
  children: r
}) : i.isValidElement(r) && r.props?.children ? i.cloneElement(r, {
  ...r.props,
  children: i.Children.map(r.props.children, l)
}) : r;
export {
  l as wrapTextNodes
};
